"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const VoxeetRTCNative_1 = __importDefault(require("./VoxeetRTCNative"));
const VoxeetRTCNode_1 = __importDefault(require("./VoxeetRTCNode"));
const bowser_1 = __importDefault(require("bowser"));
const VoxeetRTCShim_1 = require("./VoxeetRTCShim");
const VoxeetRTCUnifiedPlan_1 = __importDefault(require("./VoxeetRTCUnifiedPlan"));
const CHROME_UNIFIED_VERSION = 85;
/**
 * @ignore
 */
const browser = bowser_1.default.getParser(window.navigator.userAgent);
/**
 * @ignore
 */
class VoxeetRTC {
    static enumerateAudioDevices(type) {
        return VoxeetRTCNative_1.default.enumerateAudioDevices(type);
    }
    static enumerateVideoDevices(type) {
        return VoxeetRTCNative_1.default.enumerateVideoDevices(type);
    }
    static create(...args) {
        if (VoxeetRTCShim_1.isNode) {
            return new VoxeetRTCNode_1.default(...args);
        }
        return new VoxeetRTCUnifiedPlan_1.default(...args);
    }
    static sdpSemantics() {
        return 'unified-plan';
    }
    static sdpVersion() {
        if (browser.isBrowser('firefox', true)) {
            return 'SDP_V5';
        }
        else {
            return 'SDP_V5'; // Temporary for b-plan unique peer
        }
    }
    static createDvwcOptions(clientOptions /*boolean | DvwcParameters */, serverOptions) {
        if (clientOptions && serverOptions && serverOptions.enabled) {
            if (typeof clientOptions === 'boolean') {
                return serverOptions;
            }
            else {
                return Object.assign(serverOptions, clientOptions); // Local parts of the local config override server conifg.
            }
        }
        else {
            return null; //DVWC not supported/requested
        }
    }
}
exports.default = VoxeetRTC;
